import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import HotelTabSidebar from './Components/HotelTabSidebar'
import HRTabSidebar from './Components/HRTabSidebar'
import TuningSidebar from './Components/TuningSidebar'
import useFetchMenu from 'Common/FetchAllMenu'


import { Link, useLocation } from 'react-router-dom'

const CommonSidebar = ({ iconColor }) => {
	const user = useSelector((state) => state.user);

	const handleSidebarClick = (e) => {
		const link = e.target.closest('a');
		if (link && !link.hasAttribute('data-bs-toggle')) {
			const offcanvasElement = document.getElementById('offcanvas_Navbar');
			if (offcanvasElement) {
				const closeBtn = offcanvasElement.querySelector('.btn-close');
				if (closeBtn) {
					closeBtn.click();
				}
			}
		}
	};

	const { menu: tuningMenu, loading: tuningLoading } = useFetchMenu("tunning");

	const location = useLocation();

	const currentPage = location.pathname.split("/admin/")[1]?.split("/")[0] || "index";

	const tuningTabe = useMemo(() => {
		if (!tuningMenu?.length) return false;

		return tuningMenu.some(parent =>
			parent.children?.some(child =>
				child.page_url === currentPage
			)
		);
	}, [tuningMenu, currentPage]);

	const { menu: hotelMenu, loading: hotelLoading } = useFetchMenu('hotel');

	const hotelTabe = useMemo(() => {
		if (!hotelMenu?.length) return false;

		return hotelMenu.some(parent =>
			parent.children?.some(child => child.page_url === currentPage || currentPage === "index")
		);
	}, [hotelMenu, currentPage]);

	return (
		<aside className="ps-3 pe-2 py-3 sidebar sticky-top" id='sidebarDark' data-bs-theme="none">
			<nav className="navbar navbar-expand-xl py-0">
				<div className="offcanvas offcanvas-start" data-bs-scroll="true" tabIndex="-1" id="offcanvas_Navbar">
					<div className="offcanvas-header">
						<span className="fw-bold fs-5 text-gradient">Renbow Resort</span>
						<button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
					</div>
					<div className="offcanvas-body flex-column custom_scroll ps-4 ps-xl-0" onClick={handleSidebarClick}>
						<div className="d-flex align-items-center mb-4">
							<img className="avatar" height={"32px"} width={"32px"} src={`${user.logo}`} alt="avatar" />
							<div className="ms-2">
								<h4 className="mb-0 text-gradient title-font">{user.site_text}</h4>
							</div>
						</div>
						{/* <!-- start: Menu tab --> */}
						<ul className="nav nav-tabs tab-dynamic px-0 mb-4 mx-auto" role="tablist">
							<li className="nav-item" role="presentation">
								<Link
									className={`ps-2 pe-3 nav-link ${hotelTabe ? "active" : ""}`}
									data-bs-toggle="tab"
									to="#tab_hotels"
									role="tab"
								>HOTELS</Link>
							</li>
							<li className="nav-item" role="presentation">
								<Link
									className={`ps-2 pe-3 nav-link ${!hotelTabe && !tuningTabe ? "active" : ""}`}
									data-bs-toggle="tab"
									to="#tab_hrms"
									role="tab"
								>HRMS</Link>
							</li>
							<li className="nav-item" role="presentation">
								<Link
									className={`ps-2 pe-3 nav-link ${tuningTabe ? "active" : ""}`}
									data-bs-toggle="tab"
									to="#tab_settings"
									role="tab"
								>TUNING</Link>
							</li>
						</ul>

						<div className="tab-content">
							<div className={`tab-pane fade ${hotelTabe ? "show active" : ""}`} id="tab_hotels">
								<HotelTabSidebar iconColor={iconColor} />
							</div>
							<div className={`tab-pane fade ${!hotelTabe && !tuningTabe ? "show active" : ""}`} id="tab_hrms">
								<HRTabSidebar iconColor={iconColor} />
							</div>
							<div className={`tab-pane fade ${tuningTabe ? "show active" : ""}`} id="tab_settings">
								<TuningSidebar iconColor={iconColor} />
							</div>
						</div>

					</div>
				</div>
			</nav>
		</aside>
	)
}

export default CommonSidebar